import { ReactNode } from 'react';

import {
  getStartUrlForProvider,
  OnTrackSignupConversion,
  OnTrackSignupIntent,
  SSOButton,
} from '../SSOButton';
import { MicrosoftLogo } from './MicrosoftLogo';
import { RouteTo } from '../../../types';

type MicrosoftSSOButtonProps = {
  children?: ReactNode;
  /** The URL to redirect to after auth is complete */
  next?: string;
  /** Callback to track signup conversions */
  onTrackSignupConversion?: OnTrackSignupConversion;
  /** Callback to track signup intent */
  onTrackSignupIntent?: OnTrackSignupIntent;
  /** Query params to be added to url */
  params?: Record<string, string | number | boolean>;
  /** Routing callback to integrate with router. Will use window.href.location directly when not specified */
  routeTo?: RouteTo;
};

export function MicrosoftSSOButton({
  children = 'Continue with Microsoft',
  next,
  onTrackSignupConversion,
  onTrackSignupIntent,
  params = {},
  routeTo,
}: MicrosoftSSOButtonProps) {
  return (
    <SSOButton
      href={getStartUrlForProvider('microsoft')}
      next={next}
      onTrackSignupConversion={onTrackSignupConversion}
      onTrackSignupIntent={onTrackSignupIntent}
      params={params}
      routeTo={routeTo}
      type="microsoft-sso"
      icon={<MicrosoftLogo />}
    >
      {children}
    </SSOButton>
  );
}
